import React from 'react';
import Tasks from './Tasks';

// Stranica identična admin "Zadaci" stranici, ali koristi caregiver endpoint
// GET /api/Task/caregiver-tasks-by-date
const CaregiverTasksPage = () => (
  <Tasks
    endpoint="/api/Task/caregiver-tasks-by-date"
    showAddTask={false}
    selectable={false}
    collapseCategoriesByDefault={false}
  />
);

export default CaregiverTasksPage;
